import { makeStyles } from "@material-ui/core"

import { isSmallScreen } from "@/utils/checkDevice"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

export const CHAT_LEFT_SIDE_WIDTH = "418px"

const useStyles = makeStyles(theme => ({
	chatLeftSideContainer: {
		height: "100%",
		width: isSmallScreen ? "100%" : CHAT_LEFT_SIDE_WIDTH,
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		borderRight: `1px solid ${colors.gray[200]}`,
		maxHeight: "100%"
	},
	searchInputContainer: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50]),
		padding: theme.spacing(2)
	},
	sectionTitle: {
		fontSize: theme.typography.pxToRem(22),
		fontWeight: "bold",
		color: colors.gray[900]
	},
	instanceChipAlignment: {
		marginTop: "0.1875rem"
	},
	input: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		borderRadius: "8px",
		"& svg": {
			marginLeft: theme.spacing(1),
			marginRight: theme.spacing(2)
		},
		"&::before": {
			borderBottom: "none"
		}
	},
	fullWidth: {
		width: "100%"
	},
	fixedHeightContainer: {
		height: "100%",
		flex: 1,
		position: "relative"
	},
	disableHoverRipple: {
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor("transparent")
		}
	},
	closeChat: {
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor("transparent")
		}
	},
	grayBox: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50]),
		boxShadow: "none",
		padding: theme.spacing(1.5)
	},
	searchResultText: {
		fontWeight: "bold"
	},
	referAndEarnButton: {
		margin: theme.spacing(1, 3),
		...ColorUtil.getBackgroundAndContrastColor("white"),
		width: "100%",
		height: theme.spacing(4.5),
		fontSize: theme.typography.pxToRem(13),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[100])
		}
	}
}))

export default useStyles
